export default "__VITE_ASSET__DqjzX6sE__"